import '@/styles/globals.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Barlow, Barlow_Condensed, JetBrains_Mono } from 'next/font/google'

const sans = Barlow({
    subsets: ['latin'],
    weight: ['400', '500', '600']
})

const heading = Barlow_Condensed({
    subsets: ['latin'],
    weight: ['500', '600', '700']
})

const mono = JetBrains_Mono({
    subsets: ['latin']
})

// The Latin faces carry no Chinese glyphs, so Traditional Chinese text falls through to these system faces.
const cjkFallback = `'PingFang TC', 'Noto Sans TC', 'Microsoft JhengHei', 'Heiti TC'`

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily}, ${cjkFallback}, sans-serif;--font-app-mono:${mono.style.fontFamily}, ${cjkFallback}, monospace;--font-app-heading:${heading.style.fontFamily}, ${cjkFallback}, sans-serif}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
            </Head>

            <Component {...pageProps} />
        </div>
    )
}

export default App
